import { Outlet } from 'react-router-dom'
import React, { createContext, useEffect, useState } from "react";
import { Box, Button, Container } from "@mui/material";


const PlayWrightCSharpOutputPage = () => {
  return (
      <Box sx={{ maxHeight: "100%", width: "100%" }}>
            <Outlet />
      </Box>
  );
};


export default PlayWrightCSharpOutputPage